import { TrainerState } from './types';

export const state = (): TrainerState => initialState();

export const initialState = (): TrainerState => ({
  trainers: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['isOnline', 'active', 'lastName', 'firstName'],
        sortDesc: [true, true, false, false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: [
        'lastName',
        'firstName',
        'email',
        'userName',
        'departmentNames',
        'locations',
      ],
    },
  },
});
